module.exports = __webpack_public_path__ + "img/vermieter.e53ea28f.jpeg";